import { get } from '@/utils/request'
import useSWR from 'swr'
import { playerType, roomType, roundDataType, teamType } from '@/utils/types'
import { getServerGoAPI } from '@/utils/utils'
import { commonSWROptions, focusedSWROptions } from './useAdmin'

const fetchRound = (roundID) =>
  get(getServerGoAPI(`users/rounds/${roundID}`), {}, true).then((res) => {
    if (res.ok) {
      return res
    }
    return { round: {}, team1: {}, team2: {}, player1: {} }
  })

export const useRound = (roundID: string, needFocusRefresh = true, isOnlineGame = false) => {
  const SWROptions = needFocusRefresh ? focusedSWROptions : commonSWROptions
  return useSWR(roundID && `round-${roundID}`, () => fetchRound(roundID), {
    fallbackData: { round: { isLoading: true }, room: {}, team1: {}, team2: {} },
    ...SWROptions,
    refreshInterval: isOnlineGame ? 60000 : 900000,
  }) as {
    data: { round: roundDataType; room: roomType; team1: teamType; team2: teamType; player1: playerType; player2: playerType; player3: playerType; player4: playerType }
    mutate: any
    isValidating: boolean
  }
}

const fetchAllRound = (match_id) =>
  get(`users/rounds/all_rounds`, { match_id }).then((res) => {
    if (res.ok) {
      return res.rounds
    }
    return []
  })

export const useAllRounds = (match_id: string) => {
  return useSWR(match_id ? `all-rounds-${match_id}` : null, () => fetchAllRound(match_id), { fallbackData: [], ...focusedSWROptions }) as {
    data: roundDataType[]
    mutate: any
  }
}

export default useRound
